<template>
<div>
  <el-row>
    <el-input v-model="search" placeholder="搜索" style="width: 300px;float: right">
      <el-button slot="append" icon="el-icon-search" @click="getErroeCallbackList"></el-button>
    </el-input>
  </el-row>
  <el-table :data="tableData" style="width: 100%">
    <el-table-column align="center" prop="serverTime" label="时间" width="170">
      <template slot-scope="scope">
        {{ new Date(scope.row.serverTime * 1000).Format('yyyy-MM-dd hh:mm:ss') }}
      </template>
    </el-table-column>
    <el-table-column align="center" prop="callbackAddr" label="地址"></el-table-column>
    <el-table-column align="center" prop="description" label="描述"></el-table-column>
    <el-table-column align="center" label="操作" width="200">
      <template v-slot="{row}">
        <el-button type="danger" size="small" @click="delConfirm(row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
    class="fy"
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-sizes="[10,20,30,40]"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="totalElement"
  ></el-pagination>
</div>
</template>

<script>
export default {
  name: "ErrorCallback",
  data(){
    return{
      tableData:[],
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      search:""
    }
  },
  created() {
    this.getErroeCallbackList()
  },
  methods:{
    getErroeCallbackList() {
      let obj = {
        startTime: 0,
        endTime: 0,
        condition: this.search,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$axios
        .post(this.qoscountServerUrl + "errorPushLogsEventSubscription/findErrorPushLogsEventSubscriptionByPage", obj)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.tableData = data.data;
            this.totalElement = data.total;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getErroeCallbackList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getErroeCallbackList()
    },
    delConfirm(row){
      this.$confirm('是否确认删除该事件订阅？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delErrorCallback(row)
      }).catch(() => {

      });
    },
    delErrorCallback(row) {
      let obj = {
        id: row.id
      }
      this.$axios
        .post(this.qoscountServerUrl + "errorPushLogsEventSubscription/delete", obj)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.getErroeCallbackList()
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
  }
}
</script>

<style scoped>

</style>
